import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { Badge, Card, Form, Label, Spinner } from "reactstrap";
import { BiEdit, BiMinus, BiPlus } from "react-icons/bi";
import { useForm } from "react-hook-form";
import Required from "../../myComponents/validate/Required";
import Select from "react-select";
import { createVideoAPI, getVideoListAPI, updateVideoAPI, videoStatusUpdateAPI } from "../../api/video";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import { toast } from "react-toastify";
import { decrypt, encrypt } from "../../utils/Encrypt";
import useLogout from "../../utils/Utils";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, PreviewAltCard, Row } from "../../components/Component";
import ViewImage from "../../myComponents/modals/ViewImage";
import ViewImgAndPdf from "../../myComponents/modals/ViewImgAndPdf";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
const VideoGallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [imageOpen, setImageOpen] = useState(false);
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [modalImages, setModalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [fileType, setFileType] = useState("");
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const getFileTypeFromUrl = (url) => {
    if (typeof url !== "string") return "";
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      return "youtube";
    }
    const fileExtension = url.split(".").pop().split(/#|\?/)[0];
    return fileExtension.toLowerCase();
  };

  const handleImageClick = (index, image, inputName, passedFileType) => {
    setCurrentImageIndex(index);
    setTitleName(inputName);
    const fileType = passedFileType || getFileTypeFromUrl(image);
    setFileType(fileType);
    if (fileType === "pdf") {
      setModalImages([image]); // PDF file
    } else if (fileType === "youtube") {
      console.log("This is a YouTube link:", image);
      setModalImages([image]); // Set the YouTube URL
    } else {
      setModalImages([image]); // Image file
    }
    toggleImageModal(); // Open the modal
  };

  const logout = useLogout();
  const [column, setColumn] = useState([
    {
      name: "Video Title",
      selector: (row) => row?.video_title,
      sortable: true,
      wrap: true,
    },
    {
      name: "Video Title Hindi",
      selector: (row) => row?.hn_video_title,
      sortable: true,
      wrap: true,
    },
    {
      name: "Video URL",
      selector: (row) => row?.video_url,
      sortable: true,
      wrap: true,
    }, {
      name: "Document",
      selector: (row) => {
        const fileUrl = `${row?.video_url}`;
        const fileType = getFileTypeFromUrl(fileUrl);
        const lowerCaseFileType = fileType.toLowerCase();
        if (lowerCaseFileType === "pdf") {
          return (
            <div className="upload-image-div">
              <Button
                outline
                color="danger"
                type="button"
                onClick={() => handleImageClick(0, fileUrl, "", fileType)}
                size="xxl"
                title="View PDF"
              >
                <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
              </Button>
            </div>
          );
        } else if (lowerCaseFileType === "youtube") {
          return (
            <div className="upload-image-div">
              <Button
                outline
                color="primary"
                type="button"
                onClick={() => handleImageClick(0, fileUrl, "", fileType)}
                size="xxl"
                title="View YouTube Video"
              >
                <FaYoutube style={{ height: "1rem", width: "1rem" }} />
              </Button>
            </div>
          );
        }

        return null;
      },
      sortable: true,
      wrap: true,
      width:"90px"
    },
    {
      name: "Video Description",
      selector: (row) => row?.video_description,
      sortable: true,
      wrap: true,
    },
    {
      name: "Video Description Hindi",
      selector: (row) => row?.hn_video_description,
      sortable: true,
      wrap: true,
    },
    {
      name: "Gallery Type",
      selector: (row) => row?.type,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row?.status ? "success" : "danger"}`}>{row?.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <BiEdit />
          </Button>
        </div>
      ),
    },
  ]);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  useEffect(() => {
    getVideoData();
  }, []);

  const getVideoData = () => {
    const data = {};
    getVideoListAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleStatusUpdate = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setShowModal(true);
  };
  const handleEdit = (row) => {
    setIsOpen(!isOpen);
    setIsOpen(true);
    setMode("Edit");
    setValue("id", row.id);
    setValue("video_description", row?.video_description);
    setValue("video_title", row?.video_title);
    setValue("video_description_hn", row?.hn_video_description);
    setValue("video_title_hn", row?.hn_video_title);
    setValue("video_url", row?.video_url);
    setValue("gallery_type", { label: row?.type, value: row?.type });
    setValue("status", row?.status ? { label: "Active", value: true } : { label: "InActive", value: false });
  };

  const onFormSubmit = (data) => {
    const body = {
      video_title: data.video_title,
      video_description: data.video_description,
      hn_video_title: data.video_title_hn,
      hn_video_description: data.video_description_hn,
      video_status: data.status.value,
      type: data.gallery_type?.value,
      video_url: data.video_url,
      ...(mode == "Edit" && { id: watch("id") }),
    };
    const encryptedData = encrypt(body);
    const encryptData = {
      zero: encryptedData,
    };
    if (mode === "Add") {
      createVideoAPI(encryptData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getVideoData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateVideoAPI(encryptData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            getVideoData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };

  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };
  const confirmStatusChange = () => {
    const data = {
      id: watch("id"),
      status: watch("status"),
    };
    const updatedStatus = selectedRow.status === true ? true : false;

    const formObject = {
      id: selectedRow.id,
      status: updatedStatus,
    };
    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    videoStatusUpdateAPI(encryptData)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status === "success") {
          getVideoData();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
    setShowModal(false);
  };
  const handlePageTypeChange = (selectedOption) => {
    setValue("gallery_type", selectedOption);
    trigger("gallery_type");
  };

  return (
    <>
      <Head title={"Manage Video Gallery"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Video Gallery"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  {/* page_type */}
                  <div className="row form">
                    <Col md="4" sm="3" xxl="2">
                      <div className="form-group mb-2">
                        <Label className="from-label" htmlFor="gallery_type">
                          Select Type
                        </Label>
                        <div className="form-control-wrap ">
                          <Select
                            className=""
                            id="gallery_type"
                            options={[
                              { value: "Video", label: "Video" },
                              {
                                value: "Audio",
                                label: "Audio",
                              },
                            ]}
                            {...register("gallery_type", {
                              required: "Please select type",
                            })}
                            onChange={handlePageTypeChange}
                            value={watch("gallery_type")}
                          />
                          {errors.gallery_type && (
                            <span
                              className="invalid"
                              style={{
                                color: "#e85347",
                                fontSize: "11px",
                                fontStyle: "italic",
                              }}
                            >
                              {errors?.gallery_type?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </div>
                  <Row className="g-gs">
                    {/*Video Title */}
                    <Col md="4" sm="3" xxl="6">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="video_title">
                          {"Video/Audio Title"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter video title"}
                            type="text"
                            id="video_title"
                            {...register("video_title", {
                              required: {
                                value: true,
                                message: "Video title is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Video title must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Video title cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("video_title")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("video_title", e.target.value);
                              trigger("video_title"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.video_title && <span className="invalid">{errors?.video_title?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Video Title HN */}
                    <Col md="4" sm="3" xxl="6">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="video_title_hn">
                          {"Video/Audio Title Hindi"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter video title in hindi"}
                            type="text"
                            id="video_title_hn"
                            {...register("video_title_hn", {
                              required: {
                                value: true,
                                message: "Video/Audio title is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "Video/Audio title must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "Video/Audio title cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("video_title_hn")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("video_title_hn", e.target.value);
                              trigger("video_title_hn"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.video_title_hn && <span className="invalid">{errors?.video_title_hn?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Video/Audio URL */}
                    <Col md="10" sm="3" xxl="10">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="video_url">
                          {"Video/Audio URL"}
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter video url"}
                            type="textarea"
                            id="video_url"
                            {...register("video_url", {
                              required: {
                                value: true,
                                message: "Video/Audio url is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 15,
                                message: "Video/Audio url must be at least 15 characters long",
                              },
                              maxLength: {
                                value: 500,
                                message: "Video/Audio url cannot exceed 500 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("video_url")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("video_url", e.target.value);
                              trigger("video_url"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.video_url && <span className="invalid">{errors?.video_url?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/* Status */}
                    <Col md={`2`} sm="3" xxl="2">
                      <div className="form-group">
                        <Label className="from-label" htmlFor="status">
                          Status
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="status"
                            options={[
                              { value: true, label: "Active" },
                              { value: false, label: "InActive" },
                            ]}
                            {...register("status", {
                              required: "Please select status",
                            })}
                            onChange={handleStatusChange}
                            value={watch("status")}
                          />
                          {errors.status && (
                            <span
                              className="invalid"
                              style={{
                                color: "#e85347",
                                fontSize: "11px",
                                fontStyle: "italic",
                              }}
                            >
                              {errors?.status?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/*Video/Audio Description */}
                  <Col md="12" sm="12" xxl="12">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="video_description">
                        {"Video/Audio Description"}
                        <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <textarea
                          placeholder={"Enter video description"}
                          type="text"
                          id="video_description"
                          {...register("video_description", {
                            required: {
                              value: true,
                              message: "Video/Audio description is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 50,
                              message: "Video/Audio description must be at least 30 characters long",
                            },
                            maxLength: {
                              value: 500,
                              message: "Video/Audio description cannot exceed 500 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("video_description")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("video_description", e.target.value);
                            trigger("video_description"); // Trigger validation
                          }}
                        // onInput={(e) => {
                        //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                        // }}
                        />
                        {errors.video_description && (
                          <span className="invalid">{errors?.video_description?.message}</span>
                        )}
                      </div>
                    </div>
                  </Col>{" "}
                  {/*Video/Audio Description HN */}
                  <Col md="12" sm="12" xxl="12">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="video_description_hn">
                        {"Video/Audio Description Hindi"}
                        <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <textarea
                          placeholder={"Enter video description"}
                          type="text"
                          id="video_description_hn"
                          {...register("video_description_hn", {
                            required: {
                              value: true,
                              message: "Video/Audio description is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 50,
                              message: "Video/Audio description must be at least 30 characters long",
                            },
                            maxLength: {
                              value: 500,
                              message: "Video/Audio description cannot exceed 500 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("video_description_hn")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("video_description_hn", e.target.value);
                            trigger("video_description_hn"); // Trigger validation
                          }}
                        // onInput={(e) => {
                        //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                        // }}
                        />
                        {errors.video_description_hn && (
                          <span className="invalid">{errors?.video_description_hn?.message}</span>
                        )}
                      </div>
                    </div>
                  </Col>{" "}
                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                      </Button>
                    </div>
                  </Col>
                </Form>
              </PreviewAltCard>
            )}
          </Row>
          <MyDataTable data={data} columns={column} title={"Video/Audio"} isLoading={isLoading} />
        </Block>

        <ViewImgAndPdf
          fileType={fileType}
          titleName={titleName}
          isOpen={modalOpen}
          toggleModal={toggleModal}
          images={modalImages}
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
        />
        {/* Confirmation Modal */}
        <ConfirmModal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          onConfirm={confirmStatusChange}
          status={selectedRow?.status}
        />
      </Content>
    </>
  );
};

export default VideoGallery;
